import {
  Component,
  computed,
  DestroyRef,
  ElementRef,
  HostBinding,
  HostListener,
  inject,
  linkedSignal,
  OnInit,
  Output,
  output,
  signal,
  ViewChild,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { Message } from 'primeng/message';
import { ImportFileService } from '../../upload/components/import-file/import-file.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-file-upload',
  imports: [TranslatePipe, NgClass, Message],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
})
export class FileUploadComponent implements OnInit {
  public translationPrefix = 'fileUploader.';
  public filesDropped = output();
  importFileService = inject(ImportFileService);
  destroyRef = inject(DestroyRef);
  hasError = signal<boolean>(false);
  file = signal<File | null>(null);
  hasFileOver = signal<boolean>(false);
  fileSize = computed(() =>
    this.file() ? (this.file()!.size / 1024).toFixed(2) : null
  );
  fileSelected = output<File | undefined>();
  @ViewChild('fileInput') fileInput!: ElementRef;

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.hasFileOver.set(true);
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    this.hasFileOver.set(false);
  }

  @HostListener('document:drop', ['$event'])
  onDrop(event: DragEvent) {
    this.hasFileOver.set(false);
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer?.files[0];

    if (file && file.name.match(/\.csv$/)) {
      this.setFile(file);
    } else {
      this.hasError.set(true);
      this.file.set(null);
    }
  }

  ngOnInit() {
    this.importFileService.fileUploaded
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.setFile();
      });
  }

  onFileClick() {
    this.fileInput.nativeElement.click();
  }

  deleteFile() {
    this.setFile();
  }

  public onFileChanged(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.setFile(input.files[0]);
    }
  }

  private setFile(file?: File): void {
    this.fileInput.nativeElement.value = '';
    this.file.set(file ?? null);
    this.hasError.set(false);
    this.fileSelected.emit(file);
  }
}
